module.exports = __webpack_public_path__ + "img/xem-truoc-dktttb-icon.01519b86.svg";